/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".number[_ngcontent-%COMP%]{width:50px;height:50px;line-height:50px;text-align:center;background:#0a60a9;color:#fff;font-size:1.756em;border-radius:50%}"];
export { styles as styles };
